import { pick } from "lodash";
import { Language } from "./Language";
import { StrapiFile } from "./StrapiFile";

export type ParkConfiguration = {
  hasModifications: boolean;
  hasTrainings: boolean;
  hasEnrichments: boolean;
  hasUnavailabilities: boolean;
  hasAssignments: boolean;
  customTranslations: any;
  hasZimsImport: boolean;
};

export type Park = {
  id: string;
  name: string;
  logo: StrapiFile;
  isArchived: boolean;
  isTest: boolean;
  limitTestDate: Date;
  additionalData: any;
  language?: Language;
  maxNbUsers?: number;
} & ParkConfiguration;

export const getParkConfiguration = (park: Park): ParkConfiguration =>
  pick(park, [
    "hasModifications",
    "hasTrainings",
    "hasEnrichments",
    "hasUnavailabilities",
    "hasAssignments",
    "customTranslations",
    "hasZimsImport",
  ]) as ParkConfiguration;
